import i18n from "@/i18n/i18n";

import { PLANIT_LINK_INFO_NS } from "./getPlanitLinkInfo.i18n";

export const getPlanitLinkInfo = ({ slug }: { slug?: string }) => {
  switch (slug) {
    case "art":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/champions-of-art",
      };
    case "computing":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/digitalsparks",
      };
    case "design-tech":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/planit-primary-teaching-resources/planit-design-and-technology-primary-teaching-resources",
      };
    case "french":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/lightning-languages/french-lightning-languages",
      };
    case "geography":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/geowonderers-resources",
      };
    case "history":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/history-seekers",
      };
    case "music":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/masters-of-melody",
      };
    case "physical-education":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/pe-mastery",
      };
    case "pshe":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/twinkl-life/pshce-twinkl-life/ks1-pshe-scheme-of-work-pshe-citizenship-and-relationships-education-twinkl-life",
      };
    case "religion-worldviews":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/worldview-explorers",
      };
    case "science":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/planit-primary-teaching-resources/planit-science-primary-teaching-resources",
      };
    case "spanish":
      return {
        label: i18n.t("planit-link-label", { ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/lightning-languages/spanish-lightning-languages",
      };
    default:
      return {
        label: i18n.t("planit-link-label", { slug, ns: PLANIT_LINK_INFO_NS }),
        link: "https://www.twinkl.co.uk/resources/",
      };
  }
};
